import {
  IconDatabase,
  IconSettings,
  IconAdjustmentsCog,
  IconMessage2,
  IconChartArea,
  IconVocabulary,
  IconTool,
  IconCodeAsterix, IconHeartRateMonitor, IconVectorBezier2, IconUsers,
  IconSubtitlesEdit, IconNotebook, IconServer
} from '@tabler/icons-react'
import {IconNeo4j} from "../../../components/icons/IconNeo4j";
import {grey} from "@mui/material/colors";

export const sidebarMenuItems = [
  {
    label: "Dashboard",
    icon: <IconChartArea stroke={1.5}/>,
    to: (project) => `/project/${project?.id}`,
    roles: ["ADMIN", "MANAGER", "AGENT"]
  },
  {
    label: "Supervision",
    icon: <IconNotebook stroke={1.5}/>,
    to: (project) => `/project/${project?.id}/supervision`,
    roles: ["ADMIN", "MANAGER", "AGENT"]
  },
  {
    label: "Designer",
    icon: <IconVectorBezier2 stroke={1.5}/>,
    to: (project) => `/project/${project?.id}/flow`,
    roles: ["ADMIN", "MANAGER"]
  },
  {
    label: "Message Annotation",
    icon: <IconSubtitlesEdit stroke={1.5}/>,
    to: (project) => `/project/${project?.id}/message-annotations`,
    roles: ["ADMIN", "MANAGER", "ANNOTATOR"]
  },
  {
    label: "Knowledge Base",
    icon: <IconDatabase stroke={1.5}/>,
    roles: ["ADMIN", "MANAGER"],
    submenu: [
      {
        label: "Knowledge Database",
        icon: <IconDatabase stroke={1.5}/>,
        to: (project) => `/project/${project?.id}/knowledge-base`,
        disabled: (project) => !project?.settings?.organization,
        roles: ["ADMIN", "MANAGER"]
      },
      {
        label: "Resource Management",
        icon: <IconTool stroke={1.5}/>,
        to: (project) => `/project/${project?.id}/resource-management`,
        disabled: (project) => !project?.settings?.organization,
        roles: ["ADMIN", "MANAGER"]
      },
      {
        label: "Neo4j",
        icon: <IconNeo4j stroke={5} color={grey[800]}/>,
        to: (project) => `/project/${project?.id}/neo4j`,
        roles: ["ADMIN", "MANAGER"]
      },
    ]
  },
  {
    label: "Message Recorder",
    icon: <IconMessage2 stroke={1.5}/>,
    to: (project) => `/project/${project?.id}/asri`,
    disabled: (project) => !project?.settings?.speechToText,
    roles: ["ADMIN"]
  },
  {
    label: "MCP Registry",
    icon:<IconServer stroke={1.5}/>,
    to: (project)=>`/project/${project?.id}/mcp-registry`,
    roles: ["ADMIN"]
  },
  {
    label: "Settings",
    icon: <IconSettings stroke={1.5}/>,
    roles: ["ADMIN", "MANAGER"],
    submenu: [
      {
        label: "Project Settings",
        icon: <IconTool/>,
        to: (project) => `/project/${project?.id}/settings`,
        roles: ["ADMIN", "MANAGER"]
      },
      {
        label: "Voice Configuration",
        icon: <IconAdjustmentsCog/>,
        to: (project) => `/project/${project?.id}/configuration`,
        roles: ["ADMIN", "MANAGER"]
      },
      {
        label: "Vocabulary",
        icon: <IconVocabulary stroke={1.5}/>,
        to: (project) => `/project/${project?.id}/vocabulary`,
        roles: ["ADMIN", "MANAGER", "AGENT"]
      },
      {
        label: "Health Check Monitoring",
        icon: <IconHeartRateMonitor stroke={1.5}/>,
        to: (project) => `/project/${project?.id}/healthcheck`,
        disabled: (project) => !project?.configuration?.health_check_api,
        roles: ["ADMIN"]
      },
      {
        label: "SIP Configuration",
        icon: <IconCodeAsterix/>,
        to: (project) => `/project/${project?.id}/sip`,
        roles: ["ADMIN"]
      },
      {
        label: "Members",
        icon: <IconUsers/>,
        to: (project) => `/project/${project?.id}/members`,
        roles: ["ADMIN", "MANAGER"]
      }
    ]
  }
];
